///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/collection-category.ts"/>


module Meevo.Components.Controls.SmartMover {
    const rowHeight = 51;
    const maxRows = 10;

    let blockHeight = rowHeight * maxRows;

    export class VirtualRepeatCategory<T> extends CollectionCategory<T> implements ISmartMoverCategoryModel<T> {
        blockHeight: number;
        hasChild: boolean;
        maxRows = maxRows;

        get template(): string {
            return 'app/components/controls/smart-mover/views/virtual-repeat-category.html'
        }

        get selected(): boolean {
            return this.selectedModelsNumber > 0;
        }

        set selected(value: boolean) {
            if (this.disabled) {
                return;
            }

            this.models.forEach(model => {
                model.selected = value;
            });

            const collections = this.models.reduce((_collections, model) => {
                if (_collections.indexOf(model.collection) === -1) {
                    _collections.push(model.collection);
                }

                return _collections;
            }, []);

            for (const collection of collections) {
                const onModelValueChanged = typeof collection.onModelValueChanged === 'function'
                    && collection.onModelValueChanged.bind(collection);

                onModelValueChanged();
            }

            if (typeof this.collection.onModelValueChanged === 'function') {
                this.collection.onModelValueChanged();
            }
        }

        calculateBLockHeight() {
            this.blockHeight = this.models.length > maxRows ? blockHeight : this.models.length * rowHeight;
            this.hasChild = this.models.length > 0 && !!(this.models[0] as any).collection.childCollection;
        }

        resetModels(value: Meevo.Components.Controls.SmartMover.CollectionModel<T>[] = []) {
            super.resetModels(value);

            this.calculateBLockHeight();
        }
    }
}
